import {
    ASSIGN_DEPENDENT_QUESTION,
    UNASSIGN_DEPENDENT_QUESTION,
    GET_DEPENDENT_QUESTIONS,
    UPDATE_DEPENDENT_QUESTION,
} from "@/utils/constants/constants";
import axios from "axios";

export default {
    methods: {

        validate_tag_id(tag_id) {
            if (tag_id === null || tag_id === undefined || tag_id === '') {
                return null;
            }
            const numeric_id = Number(tag_id);
            if (isNaN(numeric_id) || numeric_id <= 0) {
                return null;
            }
            return numeric_id;
        },

        add_dependent_question(form) {
            const selected_type = this.question_types.find(
                type => type.id === form.question_type
            );

            if (!selected_type || !this.select_types.includes(selected_type.question_type)) {
                this.show_error("Dependent questions can only be added to multi-select question types.");
                return;
            }

            if (!form.dependant_questions) {
                form.dependant_questions = [];
                this.$forceUpdate();
            }

            form.dependant_questions.push({
                question_text: "",
                question_type_id: "",
                data_point_id: null,
                tag_id: null,
                question_number: "",
                options: [{ choice: "" }],
                trigger_condition: form.multi_select_choices?.[0]?.choice || "",
                is_mandatory: false,
                show_option_inputs: false,
                available_tags: [],
                parent_options: form.multi_select_choices?.map(c => c.choice) || []
            });
        },

        remove_dependent_question(form, index) {
            form.dependant_questions.splice(index, 1);
        },

        add_dependent_option(dep_question) {
            if (!dep_question.options) {
                this.$set(dep_question, "options", []);
            }
            dep_question.options.push({ choice: "" });
        },

        remove_dependent_option(dep_question, index) {
            dep_question.options.splice(index, 1);
        },

        handle_dependent_question_type_change(dep_question) {
            const type = this.question_types.find(t => t.id === dep_question.question_type_id);

            // FIXED: Use parent SELECT_TYPES via this.select_types
            dep_question.show_option_inputs = this.select_types.includes(type?.question_type);

            if (dep_question.show_option_inputs) {
                if (!dep_question.options || dep_question.options.length < 2) {
                    dep_question.options = [{ choice: "" }, { choice: "" }];
                }
            } else {
                dep_question.options = [];
            }
        },



        open_manage_dependent_modal(question_id) {
            this.current_main_question_id = question_id;
            this.parent_question = this.question_list.find(question => question.id === question_id);
            this.reset_dependent_form();
            this.get_dependent_questions_list();
            this.show_manage_dependent_modal = true;
        },

        reset_dependent_form() {
            this.new_dependent_question = {
                question_text: "",
                question_type_id: "",
                data_point_id: null,
                tag_id: null,
                question_number: "",
                options: [{ choice: "" }, { choice: "" }],
                trigger_condition: "",
                is_mandatory: false,
                show_option_inputs: false, 
            };
            this.is_editing_dependent = false;
            this.current_editing_dependent_id = null;
        },

        async get_dependent_questions_list() {
            const response = await axios.get(GET_DEPENDENT_QUESTIONS, {
                params: { main_question_id: this.current_main_question_id },
                headers: this.headers
            });

            if (response.data.status === "success") {
                this.current_dependent_questions = response.data.data.map(question => ({
                    ...question,
                    is_loading: false
                }));
            }
        },

        async assign_dependent_question() {
            if (!this.new_dependent_question.question_text.trim()) {
                this.show_error("Question text is required");
                return;
            }

            if (!this.new_dependent_question.question_type_id) {
                this.show_error("Question type is required");
                return;
            }

            if (!this.new_dependent_question.trigger_condition.trim()) {
                this.show_error("Trigger condition is required");
                return;
            }

            this.dependent_loading = true;

            try {
                const payload = {
                    main_question_id: this.current_main_question_id,
                    dependent_data: {
                        question_text: this.new_dependent_question.question_text.trim(),
                        question_type_id: this.new_dependent_question.question_type_id,
                        data_point_id: this.new_dependent_question.data_point_id || null,
                        tag_id: this.validate_tag_id(this.new_dependent_question.tag_id),
                        question_number: this.new_dependent_question.question_number || null,
                        options: this.new_dependent_question.show_option_inputs
                        ? this.new_dependent_question.options
                            .filter(opt => opt.choice.trim() !== "")
                            .map(opt => opt.choice.trim())
                        : [],
                        trigger_condition: this.new_dependent_question.trigger_condition.trim(),
                        is_mandatory: this.new_dependent_question.is_mandatory,
                        project_id: Number(this.project_id)
                    }
                };

                await axios.post(ASSIGN_DEPENDENT_QUESTION, payload, {
                    headers: this.headers
                });

                this.show_success("Dependent question added successfully");
                this.reset_dependent_form();
                this.get_dependent_questions_list();
            } catch (error) {
                this.show_error("Failed to add dependent question: " + (error.response?.data?.message || error.message));
            } finally {
                this.dependent_loading = false;
            }
        },
        edit_dependency_question(dependent_question) {
            this.current_edit_mode = 'dependent_question';
            this.is_editing_dependent = true;
            this.current_editing_dependent_id = dependent_question.id;
            this.current_depends_on_id = dependent_question.depends_on_id;
            this.new_dependent_question = {
                question_text: dependent_question.question_text,
                question_type_id: dependent_question.question_type?.id || '',
                data_point_id: dependent_question.data_point?.id || null,
                tag_id: dependent_question.tag?.id || null,
                question_number: parseInt(dependent_question.question_number || "0", 10) || 0,
                options: dependent_question.multi_select_choices?.map(c => c.choice).join(", ") ||
                    dependent_question.options?.map(c => typeof c === 'object' ? c.choice : c).join(", ") || "",
                trigger_condition: dependent_question.trigger_condition,
                is_mandatory: dependent_question.is_mandatory,
                depends_on_id: dependent_question.depends_on_id
            };
            this.current_edit_question = JSON.parse(JSON.stringify(dependent_question));
            const raw_options = dependent_question.multi_select_choices || dependent_question.options || [];
            this.current_edit_question.options = raw_options.map(opt => {
                return typeof opt === 'object' ? opt : { choice: opt };
            });
            this.current_edit_question.show_option_inputs = ['multi_select', 'single_select'].includes(
                this.current_edit_question.question_type?.question_type || ''
            );
            this.current_edit_question.question_type_id = dependent_question.question_type?.id?.toString() || '';
            this.current_edit_question.data_point_id = dependent_question.data_point?.id || null;
            this.current_edit_question.selected_tag = dependent_question.tag?.id || null;
            this.current_edit_question.available_tags = this.get_tags_for_data_point(dependent_question.data_point?.id);
            this.current_edit_question.depends_on_id = dependent_question.depends_on_id;

            this.show_edit_modal = true;
        },

        edit_dependent_question(question) {
            this.is_editing_dependent = true;
            this.current_editing_dependent_id = question.id;

            this.new_dependent_question = {
                dependent_question_id: question.id, 
                question_text: question.question_text,
                question_type_id: question.question_type_id,   // ✔ FIXED
                data_point_id: question.data_point?.id || null,
                tag_id: question.tag?.id || null,
                question_number: parseInt(question.question_number || "0", 10) || 0,
                
                // ✔ FIXED → now converts string choices into objects
                options: question.choices?.map(option => ({ choice: option })) || [],

                trigger_condition: question.trigger_condition,
                is_mandatory: question.is_mandatory,
                show_option_inputs: question.question_type_id === this.MULTI_SELECT_TYPE_ID
                    || (question.choices && question.choices.length > 0)
            };

            // FIX parent question identification
            this.parent_question = this.question_list.find(q =>
                q.dependent_questions?.some(dep => dep.id === question.id)
            );
        },


        cancel_edit_dependent() {
            this.reset_dependent_form();
        },

        async update_dependent_question() {
            const question = this.new_dependent_question || {};
            const label = `Dependent Question ${question.question_number || ''}`.trim();
            const context = question.question_text 
                ? `"${question.question_text}"`
                : "Unnamed Dependent Question";

            if (!question.question_text || !question.question_text.trim()) {
                return this.show_error(`${label} ${context}: Question text cannot be empty.`);
            }

            if (!question.question_type_id) {
                return this.show_error(`${label} ${context}: You must select a question type.`);
            }

            if (!question.trigger_condition || !question.trigger_condition.trim()) {
                return this.show_error(
                    `${label} ${context}: Trigger condition is required. This determines when the dependent question appears.`
                );
            }

            // If this dependent question requires options but none exist
            if (question.show_option_inputs && (!question.options || question.options.length < 1)) {
                return this.show_error(
                    `${label} ${context}: At least one selectable option is required for this question type.`
                );
            }

            const required = {
                question_text: "Question text is required",
                question_type_id: "Question type is required",
                trigger_condition: "Trigger condition is required"
            };

            for (const [key, msg] of Object.entries(required)) {
                const value = Reflect.get(question, key);
                if (!value || !String(value).trim()) {
                    return this.show_error(msg);
                }
            }


            this.update_dependent_loading = true;
            const payload = {
                dependent_question_id: question.dependent_question_id || this.current_editing_dependent_id,
                depends_on_id: question.depends_on_id,
                question_text: question.question_text.trim(),
                question_type_id: question.question_type_id,
                data_point_id: question.data_point_id || null,
                tag_id: this.validate_tag_id(question.tag_id),
                question_number: parseInt(question.question_number || "0", 10) || null,
                multi_select_options: Array.isArray(question.options)
                    ? question.options.map(o => (typeof o === "string" ? o : o.choice)).filter(Boolean)
                    : String(question.options || "")
                        .split(",")
                        .map(o => o.trim())
                        .filter(Boolean),
                trigger_condition: question.trigger_condition.trim(),
                is_mandatory: question.is_mandatory,
                project_id: Number(this.project_id)
            };


            try {
                const { data } = await axios.put(UPDATE_DEPENDENT_QUESTION, payload, { headers: this.headers });
                if (data?.errors) {
                    const messages = Object.entries(data.errors)
                        .map(([f, m]) => `${f}: ${m}`)
                        .join("\n");
                    this.show_error(messages);
                } else {
                    this.show_success(data?.message || "Dependent question updated successfully");
                    window.location.reload();
                    await this.get_dependent_questions_list();
                    this.is_editing_dependent = false;
                    this.reset_dependent_form();
                }
            } catch (err) {
                const msg = err.response?.data?.message || "Failed to update question. Please try again.";
                this.show_error(msg);
            } finally {
                this.update_dependent_loading = false;
            }
        },

        async unassign_dependent_question(question) {
            question.is_loading = true;

            const payload = { dependent_question_id: question.id };

            await axios.post(
                UNASSIGN_DEPENDENT_QUESTION,
                payload,
                { headers: this.headers }
            )
                .then(() => {
                    this.show_success("Dependent question removed successfully");
                    this.get_dependent_questions_list();
                })
                .catch((error) => {
                    this.show_error(
                        "Failed to remove dependent question: " +
                        (error.response?.data?.message || error.message)
                    );
                })
                .finally(() => {
                    question.is_loading = false;
                });
        }

    }
};